import { IonicErrorHandler } from 'ionic-angular';
import Raven from 'raven-js';

Raven
  .config('https://f6ae07f9dc5e4374a323d77570644d1f@sentry.papers.tech/3')
  .install();

export class SentryErrorHandler extends IonicErrorHandler {

  handleError(error) {
    super.handleError(error);

    try {
      Raven.captureException(error.originalError || error);
    }
    catch (e) {
      console.error(e);
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/sentry.service.ts